import React from 'react';
import Task from "../components/Tasks/Task";

const TaskPage = () => {
  return (
    <div>
      <Task />
    </div>
  );
};

export default TaskPage;
